
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

import StateButton from '@/components/inputs/StateButton.vue';

import schemax from '@/store/modules/schemax';
import mwx from '@/store/modules/mediumwarex';
import progressToastx from '@/store/modules/progressToastx';

import {
	SoftwareType,
	SchemaDic,
	SchemaData,
	EditState,
} from '@/store/models.def';

@Component({
	components: {
		StateButton,
	},
})
export default class AddSchema extends Vue {
	public schemaId = '';
	public parentSchemaId: string | null = null;
	public softwareType: SoftwareType = 'sql';

	public validateNow = false;
	public addSchemaState: EditState = 'active';

	public get softwareTypesVt() {
		return mwx.softwareTypesVt;
	}
	public get availableSchemas(): Array<string | { value: any; text: string }> {
		const schemas = schemax.groupedSchemas;
		if (!this.softwareType || !schemas) {
			return [];
		}
		return schemas[this.softwareType].reduce(
			(options, data) => {
				options.push(data.id);
				return options;
			},
			[{ value: null, text: 'null' }] as Array<
				string | { value: any; text: string }
			>,
		);
	}
	public get prefix() {
		return `${this.softwareType}-`;
	}
	public get id() {
		return `${this.prefix}${this.schemaId}`;
	}
	public get validateSchemaId() {
		if (!this.validateNow) {
			return null;
		}
		if (this.schemaId.length === 0) {
			return false;
		}
		// check existing name
		if (schemax.allSchemas.find((sm) => sm.id === this.id)) {
			return false;
		}
		return true;
	}
	public get validateParentId() {
		if (!this.validateNow) {
			return null;
		}
		if (this.parentSchemaId === this.id) {
			return false;
		}
		if (
			this.parentSchemaId !== null &&
			!schemax.allSchemas.find((sm) => sm.id === this.parentSchemaId)
		) {
			return false;
		}
		return true;
	}
	public get addSchemaLabel() {
		const labels = {
			active: 'Add New Schema',
			sending: 'Adding...',
			done: 'Added New Schema',
		};
		return labels[this.addSchemaState];
	}
	public async addSchema() {
		if (this.addSchemaState !== 'active') {
			return;
		}
		this.validateNow = true;
		if (!this.validateSchemaId || !this.validateParentId) {
			return;
		}
		const submission: SchemaData = {
			id: this.id,
			softwareType: this.softwareType,
			parentId: this.parentSchemaId,
			model: '[]',
			solution: '[]',
		};
		const toastId = await progressToastx.add({
			title: `${this.id}`,
			state: `Adding new schema...`,
			variant: 'info',
		});
		this.addSchemaState = 'sending';
		this.validateNow = false;
		const result = await schemax.addSchema(submission);
		this.addSchemaState = 'active';
		if (result.success) {
			progressToastx.done({ id: toastId, state: `New schema added!` });
			this.schemaId = '';
			this.parentSchemaId = null;
		} else {
			this.validateNow = true;
			progressToastx.error({ id: toastId, state: result.errorMessage });
		}
	}
}
